export const sendFeedbackQuery = (data) => {
    return fetch('/api/v2/accounts/deactivation-feedback/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const stayAndStayQuery = () => {
    return fetch('/api/v2/accounts/subscription/stay-and-save/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const cancelationQuery = (cancel_immediately = false) => {
    return fetch('/api/v2/accounts/subscription/', {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify({
            cancel_immediately,
        }),
    });
};
